import { IPostCode } from '@interfaces/api/IPostCode'
import axios, { AxiosResponse } from 'axios'

interface AddressComponent {
    long_name: string
    short_name: string
    types: string[]
}

interface GeocodeResult {
    status: string
    address_components: AddressComponent[]
    geometry: {
        location: {
            lat: number
            lng: number
        }
    }
}

export default async function GetPostCode(cep: string): Promise<IPostCode | undefined> {
    cep = cep.replace(/[^\d]/g, '')

    const geocodeResponse: AxiosResponse = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${cep}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
    )
    const geocodeData: GeocodeResult = geocodeResponse.data.results[0]

    if (geocodeResponse.data.status === 'OK') {
        return processGeocodeData(geocodeData)
    }
    return undefined
}

function processGeocodeData(geocodeData: GeocodeResult): IPostCode {
    const addressComponents: AddressComponent[] = geocodeData.address_components

    return {
        data: {
            neighborhood: getAddressComponent(addressComponents, 'sublocality_level_1').long_name,
            city: getAddressComponent(addressComponents, 'administrative_area_level_2').long_name,
            streetAddress: getAddressComponent(addressComponents, 'route').long_name,
            postcode: getAddressComponent(addressComponents, 'postal_code').long_name,
            state: getAddressComponent(addressComponents, 'administrative_area_level_1').short_name,
            latitude: geocodeData.geometry.location.lat,
            longitude: geocodeData.geometry.location.lng,
        },
    }
}

function getAddressComponent(addressComponents: AddressComponent[], type: string): AddressComponent {
    const component = addressComponents.find((item) => item.types.includes(type))
    if (component) {
        return component
    }

    return {
        long_name: '',
        short_name: '',
        types: [],
    }
}
